import axios from "axios";
import config from "config/config";
import type { Airport as AirportProps } from "@airhelp/react-ui-components";
import { airportsListMock } from "./mocks/getAirports";

const developmentEnvironment = config.buildEnv === "development";

const getAirports = async (query: string): Promise<AirportProps[]> => {
  const url = `${config.webappUrl}/api/airports?q=${query}`;

  try {
    const { data } = await axios.get(url);
    return data.airports;
  } catch (error) {
    if (developmentEnvironment) {
      return airportsListMock;
    }
    throw Error(error.message);
  }
};

export default getAirports;
